import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, isRef as _isRef, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "h-screen flex flex-col bg-neutral-50 dark:bg-neutral-900"
}
const _hoisted_2 = { class: "flex items-center gap-2" }
const _hoisted_3 = { class: "flex flex-1 min-h-0 overflow-hidden" }
const _hoisted_4 = { class: "flex-1 overflow-y-auto" }
const _hoisted_5 = { class: "max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-6" }
const _hoisted_6 = {
  key: 1,
  class: "flex w-full h-screen items-center justify-center"
}

import { useAuthStore } from "~/stores/auth";


export default /*@__PURE__*/_defineComponent({
  __name: 'documentation',
  async setup(__props) {

let __temp: any, __restore: any

const auth = useAuthStore();
;(
  ([__temp,__restore] = _withAsyncContext(() => auth.isAuthenticated())),
  await __temp,
  __restore()
);

const isConnected = ref(auth.isConnected);
const isVerified = ref(auth.user?.is_verified);

const sidebarOpen = ref(true);
const route = useRoute();

// Close sidebar on mobile when route changes
watch(
  () => route.path,
  () => {
    if (import.meta.client && window.innerWidth < 1024) {
      sidebarOpen.value = false;
    }
  },
);

useHead({
  title: "Documentation",
  meta: [{ name: "description", content: "FamilyAxis Documentation" }],
  bodyAttrs: {
    class: "documentation-layout",
  },
});

return (_ctx: any,_cache: any) => {
  const _component_UColorModeImage = _resolveComponent("UColorModeImage")!
  const _component_UButton = _resolveComponent("UButton")!
  const _component_UserDropdown = _resolveComponent("UserDropdown")!
  const _component_UHeader = _resolveComponent("UHeader")!
  const _component_DocumentationSidebar = _resolveComponent("DocumentationSidebar")!
  const _component_USidebar = _resolveComponent("USidebar")!

  return (_unref(isConnected) && _unref(isVerified))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_UHeader, {
          toggle: false,
          class: "shrink-0 border-b border-neutral-200 dark:border-neutral-800 bg-white dark:bg-neutral-900",
          ui: {
        container: 'max-w-full',
        body: 'px-4 sm:px-6 lg:px-8',
      }
        }, {
          title: _withCtx(() => [
            _createVNode(_component_UColorModeImage, {
              id: "hometop",
              light: "/images/logo_light.svg",
              dark: "/images/logo_dark.svg",
              class: "h-6"
            }),
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "font-semibold text-neutral-900 dark:text-neutral-100" }, "Help", -1))
          ]),
          right: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_UButton, {
                icon: "i-heroicons-bars-3",
                variant: "ghost",
                color: "neutral",
                class: "lg:hidden",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (sidebarOpen.value = true))
              }),
              _createVNode(_component_UButton, {
                icon: "i-heroicons-home",
                variant: "ghost",
                color: "neutral",
                to: "/user",
                class: "rounded-full"
              }),
              _createVNode(_component_UserDropdown)
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_USidebar, {
            open: _unref(sidebarOpen),
            "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => (_isRef(sidebarOpen) ? (sidebarOpen).value = $event : null)),
            collapsible: "icon",
            mode: "slideover",
            rail: "",
            title: "Reference Docs",
            ui: {
          container: 'top-(--ui-header-height) bottom-0 h-[calc(100vh-var(--ui-header-height))]',
        }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DocumentationSidebar)
            ]),
            _: 1
          }, 8, ["open"]),
          _createElementVNode("main", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ])
        ])
      ]))
    : (_unref(isConnected) && !_unref(isVerified))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("div", { class: "text-center" }, [
            _createElementVNode("h3", { class: "text-xl font-bold mb-2" }, "Please Verify your Email address"),
            _createElementVNode("p", { class: "text-neutral-600 dark:text-neutral-400" }, " You need to verify your email address to access the documentation. ")
          ], -1)
        ]))]))
      : _createCommentVNode("", true)
}
}

})